const keyboardNavigationClass = 'is-keyboard-navigation';
const initializationFlag = '__asportKeyboardNavigationModeInitialized';

// Expose focus rings after Tab navigation while keeping pointer-focused form controls unchanged.
export const initKeyboardNavigationMode = () => {
	// Arena and Videotools can run in the same document, so only register the shared listeners once.
	if (window[initializationFlag]) return;
	window[initializationFlag] = true;

	document.addEventListener('keydown', event => {
		if (event.key === 'Tab') document.documentElement.classList.add(keyboardNavigationClass);
	}, true);

	const pointerEventName = 'onpointerdown' in window ? 'pointerdown' : 'mousedown';
	document.addEventListener(pointerEventName, () => {
		document.documentElement.classList.remove(keyboardNavigationClass);
	}, true);
};
